import { render, staticRenderFns } from "./EsgBaseDashboardCard.vue?vue&type=template&id=72b756b2&scoped=true"
import script from "./EsgBaseDashboardCard.vue?vue&type=script&lang=js"
export * from "./EsgBaseDashboardCard.vue?vue&type=script&lang=js"
import style0 from "./EsgBaseDashboardCard.vue?vue&type=style&index=0&id=72b756b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b756b2",
  null
  
)

export default component.exports